import React, { useLayoutEffect, useRef } from "react";
import { Box, useTheme } from "@mui/material";

export const APP_HEADER_HEIGHT_VAR = "--app-header-height";
export const PAGE_HEADER_HEIGHT_VAR = "--v2-page-header-height";

interface PageHeaderV2CstProps {
  children: React.ReactNode;
}

const PageHeaderV2Cst: React.FC<PageHeaderV2CstProps> = ({ children }) => {
  const theme = useTheme();
  const ref = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const element = ref.current;
    if (!element) return undefined;
    const root = document.documentElement;
    const update = () =>
      root.style.setProperty(
        PAGE_HEADER_HEIGHT_VAR,
        `${element.offsetHeight}px`,
      );
    update();
    const observer = new ResizeObserver(update);
    observer.observe(element);
    return () => {
      observer.disconnect();
      root.style.removeProperty(PAGE_HEADER_HEIGHT_VAR);
    };
  }, []);

  return (
    <Box
      ref={ref}
      sx={{
        position: "sticky",
        top: `var(${APP_HEADER_HEIGHT_VAR}, 180px)`,
        zIndex: 99,
        mt: -1,
        pt: 1,
        pb: 0.5,
        maxHeight: `calc(100vh - var(${APP_HEADER_HEIGHT_VAR}, 180px))`,
        overflowY: "auto",
        overflowX: "hidden",
        backgroundColor: theme.palette.background.default,
        transition: "top 700ms ease",
      }}
    >
      {children}
    </Box>
  );
};

export default PageHeaderV2Cst;
